import { Descriptions } from 'antd';
import * as moment from 'moment';
import React from 'react';
import { ESTADOS_INSPECCION } from '../../../utils';
import { formatoMonedaGenerico } from '../../../utils/converters';

const NO_DISPONIBLE = 'No disponible';
const Descripciones = ({ fields }) => {
  const final = () => {
    if (fields.resultado === 'VERIFICACION') {
      return [
        <>
          <Descriptions.Item label="Resultado de Final">
            {fields.resultado_final || NO_DISPONIBLE}
          </Descriptions.Item>
          <Descriptions.Item label="Inspector Responsable:">
            {fields.inspector_final || NO_DISPONIBLE}
          </Descriptions.Item>
        </>
      ];
    }
    return [];
  };
  return (
    <>
      <Descriptions
        title="Datos del Vehículo"
        style={{ textAlign: 'left', paddingBottom: 40 }}
        labelStyle={{ width: '20%' }}
        contentStyle={{ width: '30%' }}
        column={{ md: 2, sm: 1, xs: 1 }}
        bordered
        size="small"
      >
        <Descriptions.Item label="Nombre del Asegurado">
          {fields?.solicitud?.cotizacion?.persona?.nombres || NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Marca">
          {fields?.solicitud?.cotizacion?.vehiculo?.marca?.descripcion ||
            NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Modelo">
          {fields.solicitud?.cotizacion?.vehiculo?.modelo?.descripcion ||
            NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Submodelo">
          {fields.solicitud?.cotizacion?.vehiculo?.submodelo?.descripcion ||
            NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Año">
          {fields.solicitud?.cotizacion?.vehiculo?.aniosubmodelo?.descripcion ||
            NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Monto">
          {fields.solicitud?.cotizacion?.vehiculo?.monto_asegurado
            ? formatoMonedaGenerico(
                fields.solicitud?.cotizacion?.vehiculo?.moneda,
                fields.solicitud?.cotizacion?.vehiculo?.monto_asegurado
              )
            : NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Chassis">
          {fields.solicitud?.cotizacion?.vehiculo?.chassis || NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Chapa">
          {fields.solicitud?.cotizacion?.vehiculo?.chapa || NO_DISPONIBLE}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        title="Datos de la Inspección"
        style={{ textAlign: 'left', paddingBottom: 40 }}
        labelStyle={{ width: '20%' }}
        contentStyle={{ width: '30%' }}
        column={{ md: 2, sm: 1, xs: 1 }}
        bordered
        size="small"
      >
        <Descriptions.Item label="Fecha de Solicitud de Inspección">
          {fields?.fecha_solicitud_inspeccion
            ? moment(fields?.fecha_solicitud_inspeccion).format(
                'DD/MM/YYYY HH:mm'
              )
            : NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Estado de Inspección">
          {fields?.estado ? ESTADOS_INSPECCION[fields?.estado] : NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Fecha de Subida de Fotografías">
          {fields?.fecha_subida_fotos
            ? moment(fields?.fecha_subida_fotos).format('DD/MM/YYYY HH:mm')
            : NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Geolocalización">
          {fields.latitud !== null ? (
            <a
              style={{ display: 'table-cell' }}
              href={`https://www.google.com.py/maps/place/+${fields.latitud},${fields.longitud}`}
              target="_blank"
              rel="noreferrer"
            >
              {fields.latitud}, {fields.longitud}
            </a>
          ) : (
            NO_DISPONIBLE
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Fecha de Realización del Informe">
          {fields?.fecha_informe_inspeccion
            ? moment(fields?.fecha_informe_inspeccion).format(
                'DD/MM/YYYY HH:mm'
              )
            : NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Comentarios Generales">
          {fields?.comentarios || NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Resultado de Inspección">
          {fields?.resultado || NO_DISPONIBLE}
        </Descriptions.Item>
        <Descriptions.Item label="Inspector Responsable:">
          {fields?.inspector_name || NO_DISPONIBLE}
        </Descriptions.Item>

        {final()}
      </Descriptions>
    </>
  );
};

export default Descripciones;
